const resource = {
  "forgot": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Forgot?"])},
  "login": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Login"])},
  "loginTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Login"])},
  "password": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Password"])},
  "submit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Login"])},
  "welcome": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Welcome"])}
}
export default resource